import { render, staticRenderFns } from "./yhgProductShowAdd.vue?vue&type=template&id=698f3730&"
import script from "./yhgProductShowAdd.vue?vue&type=script&lang=js&"
export * from "./yhgProductShowAdd.vue?vue&type=script&lang=js&"
import style0 from "./yhgProductShowAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports